import {FormState} from '~/library/form-models.v1';

export type TwoFaConfirmationFormState = ReturnType<typeof TwoFaConfirmationFormState>;
export const TwoFaConfirmationFormState = () =>
    FormState({
        codeFromSms: '',
    });
